import React, { useState } from 'react';
import Modal from './Modal';

const ResetPasswordModal = ({ open, onClose, onSubmit, username }) => {
  const [pw, setPw] = useState('');
  const pwLength = pw.length >= 8;
  const pwSpaces = pw === pw.trim();
  const canSubmit = pwLength && pwSpaces;
  return (
    <Modal open={open} onClose={onClose} title={`Reset Password for ${username}`}> 
      <div className="space-y-4">
        <input
          type="password"
          className="input-field"
          placeholder="Temporary password"
          value={pw}
          onChange={(e) => setPw(e.target.value)}
        />
        <div className="text-sm" aria-live="polite">
          <div>{pwLength ? '✓' : '✗'} At least 8 characters</div>
          <div>{pwSpaces ? '✓' : '✗'} No leading or trailing spaces</div>
        </div>
        <div className="flex justify-end space-x-2 pt-2">
          <button onClick={onClose} className="btn-outline">Cancel</button>
          <button onClick={() => onSubmit(pw)} disabled={!canSubmit} className="btn-primary disabled:opacity-50">Reset</button>
        </div>
      </div>
    </Modal>
  );
};

export default ResetPasswordModal;
